import React, { useContext, useEffect, useState } from 'react'
import styles from './styles.module.css'
import { useDispatch, useSelector } from 'react-redux'
import { Checkbox, Input, Select } from '../../../../components/ModalInputs'
import ModalFooter from '../../../../components/ModalFooter/ModalFooter'
import { getTeacherByGroupId, addGroupUser } from '../../../../actions/permissions'
import Loader from '../../../../components/Loader'
import CustomSelect from '../../../../components/CustomSelect'
import moment from 'moment'
import { OrderContext } from '../../../../utils/context'
import { arrayForSelect } from '../../../../utils/arrayForSelect'

export default function DismissalEmployee({ data, addMode }) {

  const dispatch = useDispatch()

  const { values, personnelList, setFieldValue, handleChange, specFields, error } = useContext(OrderContext)

  const { courses } = useSelector(state => state.common)

  useEffect(() => {
    // data && dispatch(getTeacherByGroupId(data));
  }, [data])

  const renderSelect = specFields && specFields.find(item => item.displaylabel.slice(0, 18) === 'Причина увольнения');


  // const renderMoney = (money) => {
  //   const mo = +money.toLocaleString("ru-RU", { style: "currency", currency: "RUB" })
  //   return mo
  // }

  return (
    <>
      <div className={styles.modalMain}>
        <div className={styles.tabWrapper}>
          <div className={styles.inputsRow}>
            <CustomSelect
              title='ФИО'
              valuesName="mid"
              options={arrayForSelect(personnelList, 'fio', 'mid')}
              value={personnelList && personnelList?.find(item => item.mid == values.mid)?.fio}
              setFieldValue={setFieldValue}
              withoutAll
              width={300}
            />
          </div>
          <div className={styles.inputsRow}>
            <Input
              // error={values.date === '' ? 'Обязательное поле' : ''}
              type='date'
              label='Дата'
              name='date'
              value={moment(values.date).format('YYYY-MM-DD')}
              onChange={handleChange}
            />
          </div>
          <div className={styles.inputsRow}>
            {/* // TODO */}
            <Select
              label='Причина увольнения'
              name='string4'
              value={values.string4}
              error={error('string4')}
              onChange={handleChange}
            // onBlur={handleBlur}
            >
              <option value=''>Не выбран</option>
              {renderSelect?.param_data?.map(item => <option value={item.idorderspecdicts}>{item.value}</option>)}
            </Select>
            <Input
              label='Комментарий'
              name='string5'
              value={values.string5}
              // error={error('string5')}
              onChange={handleChange}
              style={{ width: '300px' }}
            />
          </div>
          <div className={styles.inputsRow}>
            <Input
              label='Единовременное денежное вознаграждение'
              name='money'
              type='number'
              // value={values.money}
              value={`${values.money} руб.`} // залипуха
              error={error('money')}
              onChange={handleChange}
              style={{ width: '300px' }}
            />
            <Input
              label='Примечание'
              name='string'
              value={values.string}
              // error={error('string')}
              onChange={handleChange}
              style={{ width: '300px' }}
            />
          </div>
          <div className={styles.inputsRow}>
            <Input
              label='Компенсация за отпуск'
              name='money2'
              type='number'
              // value={values.money2}
              value={`${values.money2} руб.`}
              error={error('money2')}
              onChange={handleChange}
              style={{ width: '300px' }}
            />
            <Input
              label='Примечание'
              name='string2'
              value={values.string2}
              // error={error('string2')}
              onChange={handleChange}
              style={{ width: '300px' }}
            />
          </div>
          <div className={styles.inputsRow}>
            <Input
              label='Удержать ЗП'
              name='money3'
              type='number'
              // value={values.money3}
              value={`${values.money3} руб.`}
              error={error('money3')}
              onChange={handleChange}
              style={{ width: '300px' }}
            />
            <Input
              label='Примечание'
              name='string3'
              value={values.string3}
              // error={error('name')}
              onChange={handleChange}
              style={{ width: '300px' }}
            />
          </div>
        </div>
      </div >
    </>
  )
}
